<template>
  <div>
    <b-form v-if="userInfo">
      <b-card style="margin: 1%">
        <b-row>
          <b-col md="6" xl="6" cols="6">
            <b-form-group label-align="right" :label="$t('WebPage')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="text"  v-model="userInfo.web_page"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Legal address')" label-cols="4" label-cols-xl="4" label-cols-md="4"  >
              <b-form-input type="text"  v-model="userInfo.juridical_address" :disabled="!userInfo.is_juridical"/>
              <b-form-checkbox   v-model="userInfo.is_juridical">{{ $t('Legal person') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" v-model="userHouse" disabled :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                <b-input-group-append>
                  <b-button @click.stop="clear" variant="secondary" size="sm">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Actual address')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="text"  v-model="userInfo.actual_address"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('District')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.district"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Building')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.building"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Porch')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.entrance"/>
            </b-form-group>
          </b-col>
          <b-col md="6" xl="6" cols="6" align-self="center" >
            <b-form-group label-align="right" :label="$t('Floor')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.floor"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Apartment')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="text"  v-model="userInfo.flat_number"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Work phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.work_telephone"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Home phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.home_telephone"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Mobile phone')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.mobile_telephone"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('ICQ number')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="number"  v-model="userInfo.icq_number"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Email')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
              <b-form-input type="text"  v-model="currentRow.email" @change="removeEmail"/>
              <b-form-checkbox  v-model="userInfo.is_send_invoice" :disabled="!currentRow.email.length" false-value="">{{ $t('Send invoices by email') }}</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-form>

    <b-modal v-if="userInfo" ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="userInfo.house_id" @hideFormHouse="hideFormHouse" @displayHouse="displayHouse" @makeToasts="makeToasts"></FormHouse>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormHouse from './formHouse'

export default {
  components: {
    FormHouse
  },
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      userHouse: '',
      houses: []
    }
  },
  methods: {
    removeEmail (checked) {
      this.userInfo.is_send_invoice = checked ? !this.currentRow.email.length : this.currentRow.email.length
    },
    clear () {
      this.userHouse = ''
      this.userInfo.house_id = '0'
    },
    displayHouse () {
      this.userHouse = ''
      if (this.houses && this.userInfo) {
        for (let i in this.houses) {
          if (this.houses[i].house_id === this.userInfo.house_id) {
            let curHouse = this.houses[i]
            delete curHouse.connect_date
            delete curHouse.zones
            for (let j in curHouse) {
              if (curHouse[j].length > 0 || curHouse[j] > 0) {
                if (this.userHouse.length > 0) {
                  this.userHouse += ', '
                }
                this.userHouse += curHouse[j]
              }
            }
            break
          }
        }
      }
    },
    async load () {
      this.userHouse = ''
      this.houses = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_HOUSES).then(response => { return response.data })
      this.displayHouse()
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    }
  },
  watch: {
    userInfo: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/contacts/main.vue